<template>
<!-- touch端提示弹框 -->
    <div class="tp-error-message-toast">
      <transition name="toast-fade">
        <div class="content"  v-show="visible">
          <img src="../assets/img/errorToast.png" height="14" width="14" alt="">
          <span>{{message}}</span>
        </div>
      </transition>
    </div>
</template>
<script>
import { setTimeout } from 'timers'
export default {
  data () {
    return {
      visible: false
    }
  },
  props: ['message'],
  mounted () {
    let _this = this
    setTimeout(function () {
      document.body.removeChild(_this.dom)
      _this.visible = false
    }, 2000)
  }
}
</script>
<style  lang="less">
.tp-error-message-toast {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  .content {
    font-size:14px;
    font-family:MicrosoftYaHei;
    color:rgba(236,81,86,1);
    border-radius:2px;
    background: #fff;
    line-height:19px;
    max-width: 80%;
    padding: 16px 20px;
    min-width: 320px;
    display: inline-block;
    margin: 66px auto 0;
    box-shadow:0px 1px 6px 0px rgba(0,128,187,0.2);
    img {
      display: inline-block;
      vertical-align: middle;
      margin-top: -3px;
    }
  }
}
.toast-fade-enter-active {
    animation-name: slideInUp;
    animation-duration: 0.3s;
    animation-fill-mode: both;
}
.toast-fade-leave-active {
    animation-name: slideOutDown;
    animation-duration: 0.2s;
    animation-fill-mode: both;
}
@keyframes slideInUp {
    0% {
        transform: translate3d(0, -66px, 0);
        visibility: visible;
    }
    50% {
        transform: translate3d(0, -33px, 0);
        visibility: visible;
    }
    to {
        transform: translateZ(1);
    }
}
@keyframes slideOutDown {
    0% {
        transform: translateZ(0);
    }
    to {
        visibility: hidden;
        transform: translate3d(0, 100%, 0);
    }
}
</style>





// WEBPACK FOOTER //
// common/commonModule/passport/components/toast.vue